import { useEffect } from 'react'

import type { CheckboxGroupInterface } from 'interfaces'
import { Tooltip } from '../../atoms/Tooltip'

export function CheckboxGroup({
  name,
  legend,
  errorMessage,
  checkboxes,
  disabled,
  formItemClass,
  legendClass,
  register,
  registerOptions,
  unregister
}: CheckboxGroupInterface) {
  useEffect(() => {
    return () => {
      unregister && unregister(name)
    }
  }, [])

  return (
    <div className={`wc-form-item${formItemClass ? ' ' + formItemClass : ''}`}>
      <fieldset className="wc-fieldset" disabled={disabled}>
        <legend
          className={`wc-fieldset__legend${
            legendClass ? ' ' + legendClass : ''
          }`}
        >
          {legend ?? ''}
        </legend>
        {errorMessage && (
          <span
            className="field-validation-error wc-assist wc-assist--error"
            role="alert"
          >
            {errorMessage}
          </span>
        )}
        {checkboxes &&
          checkboxes.map(({ value, text, subText, tooltip }) => (
            <div className="wc-checkbox mb-6" key={value}>
              <input
                {...register(name, registerOptions)}
                type="checkbox"
                id={`${name}-${value}`}
                value={value}
              />
              <label htmlFor={`${name}-${value}`}>
                {subText ? (
                  <span className="flex flex-col">
                    <h6 className="mb-0">{value}</h6>
                    <p>{subText}</p>
                  </span>
                ) : (
                  <span>
                    {text ?? value}{' '}
                    {tooltip && (
                      <Tooltip parentClass="ml-4" a11yText={tooltip}>
                        {tooltip}
                      </Tooltip>
                    )}
                  </span>
                )}
              </label>
            </div>
          ))}
      </fieldset>
    </div>
  )
}
